// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root{
  --headerHeight:4rem;
  --headerHeightMobile:calc(var(--headerHeight)*0.8);
}

.overflow-menu{
  width:100%;
  background-color:inherit;
  border:none;
}

.overflow-menu .main-nav-links{
    padding-left:0;
    list-style-type:none;
    display:flex;
    flex:1 0 auto;
    flex-direction:row;
    padding:0;
    padding-top:1.25rem;
    margin:0;
    white-space:nowrap;
  }

.overflow-menu .main-nav-links__item{
      display:flex;
      padding-bottom:0.75rem;
      margin-right:1rem;
      cursor:pointer;
      border-bottom:0.25rem solid #fff;
    }

@media (width > 1024px){

.overflow-menu .main-nav-links__item{
        margin-right:1.5rem;
        outline:none
    }
      }

.overflow-menu .main-nav-links__item--not-clickable{
        cursor:default;
      }

.overflow-menu .main-nav-links__item--active,
      .overflow-menu .main-nav-links__item:active,
      .overflow-menu .main-nav-links__item:hover,
      .overflow-menu .main-nav-links__item:focus,
      .overflow-menu .main-nav-links__item:focus-within{
        color:#ef3e39;
        border-bottom-color:#ef3e39;
      }

.overflow-menu .main-nav-links__link{
      display:inline-block;
      padding:1rem 0;
      font-weight:700;
      color:#424242;
      -webkit-text-decoration:none;
      text-decoration:none;
      cursor:pointer;
      border-bottom:0.25rem solid #fff;
      padding:0;
      text-align:center;
      white-space:nowrap;
      -webkit-user-select:none;
              user-select:none;
    }

.overflow-menu .overflow-more{
    width:3.5rem;
    -webkit-user-select:none;
            user-select:none;
  }

.overflow-menu .overflow-more .overflow-menu{
      height:100%;
      font-weight:600;
      color:#424242;
      text-align:left;
      white-space:nowrap;
      -webkit-text-decoration:none;
      text-decoration:none;
      cursor:pointer;
    }

.overflow-menu .overflow-more .overflow-menu--active,
      .overflow-menu .overflow-more .overflow-menu:active,
      .overflow-menu .overflow-more .overflow-menu:hover,
      .overflow-menu .overflow-more .overflow-menu:focus,
      .overflow-menu .overflow-more .overflow-menu:focus-within{
        border-bottom-color:#ef3e39;
      }

.overflow-menu .overflow-more .dropdown-menu__opener:focus{
      outline:none;
    }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
